export const formBilling = () => {
  const checkoutBillingFieldsWrapper = document.querySelector(
    ".woocommerce-billing-fields__field-wrapper"
  );

  const legalPersonCheckbox = document.getElementById("show-legal-person");

  const companyName = document.getElementById("billing_company_field");
  const companyVat = document.getElementById("billing_company_vat_code_field");
  const companyNumber = document.getElementById("billing_company_number_field");
  const companyAddress = document.getElementById(
    "billing_company_address_field"
  );

  let companyInfoFlag = document.createElement("input");

  companyInfoFlag.type = "hidden";
  companyInfoFlag.name = "company_info_field";
  companyInfoFlag.id = "company_info_field";
  companyInfoFlag.value = 1;

  if (legalPersonCheckbox && checkoutBillingFieldsWrapper) {
    legalPersonCheckbox.addEventListener("click", () => {
      companyName.classList.toggle("d-none");
      companyVat.classList.toggle("d-none");
      companyNumber.classList.toggle("d-none");
      companyAddress.classList.toggle("d-none");

      if (legalPersonCheckbox.checked) {
        checkoutBillingFieldsWrapper.appendChild(companyInfoFlag);
      } else {
        checkoutBillingFieldsWrapper.removeChild(companyInfoFlag);
      }
    });
  }
};
